<template>
	<div class="f-user-slides">
		<div class="row" v-if="edituser.presentation && edituser.presentation.charts">
			<div class="col-xs-6 col-sm-4 col-md-3" v-for="data in presentation.charts" :key="data.id">

				<router-link
				v-if="data.id > 0"
				class="router-link st-chart-preview"
				:class="{ 'c-chart-list-item--trashed': data.id <= 0, 'st-chart-preview--show': !hide, 'st-chart-preview--hide': hide, 'st-chart-preview--small': small }"
				:to="{ name: field.namespace + '-chart', params: { chartid : data.id }}"
		    	>
			    	<c-chart-preview
			    		:data="data"
			    		:visible="data.visible"
			    		:trashed="data.trashed"
			    		:locked="(!data.permissions.can_edit && !data.permissions.can_change_edit)">
			    	</c-chart-preview>
				</router-link>
			</div>
		</div>

		<div class="row" v-if="caneditor">
			<div class="col-xs-12">
				<router-link
				type="button"
				class="inline-block st-btn st-btn--small"
				:to="{ name: field.namespace + '-editor' }"
				>{{ $t('to the editor') }}</router-link>
			</div>
		</div>
		<div class="row" v-else>
			<div class="col-xs-12">
				{{ $t('no Presentation') }}
			</div>
		</div>
	</div>
</template>

<script>

import CChartPreview from '@/components/p-editor/c-chart-preview';
import fieldvalidation from '@/helpers/fieldvalidation';

export default {
	name: 'f-user-slides',
	components: {
		CChartPreview
	},
	computed: {
		caneditor(){
			return ((!this.edituser.addablecharts || Object.keys(this.edituser.addablecharts).length <= 0) && (!this.edituser.charts || Object.keys(this.edituser.charts).length <= 0));
		},
		presentation(){
			return this.$store.getters.presentation;
		},
		edituser(){
			return this.$store.getters.edituser;
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	data(){
		return {
			hide: false,
			small: false,
			trashed: false,
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/f-user-slides.vue